import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  now: new Date(),
};

const GlobalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setDate(state, action) {
      state.now = action.payload;
    },
  },
});

export const { setLoading } = GlobalSlice.actions;

export default GlobalSlice.reducer;

/*
dispatch({
			type: 'global/setDate',
			payload: new Date(),
		});

const globalStore = useStore().getState();
*/
